module.exports = __webpack_public_path__ + "static/template-bg-b35cc377648b588293dc380d1f849b19.png";